module.exports = __webpack_public_path__ + "static/media/no-data.d66f1453.svg";